module.exports = __webpack_public_path__ + "static/media/5.0ad64363.png";